import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-concurrent-access',
  templateUrl: './concurrent-access.component.html',
  styleUrls: ['./concurrent-access.component.scss']
})
export class ConcurrentAccessComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  onRetryClick() {
    this.location.back();
  }

}
